import { useState, useEffect } from 'react';
import supabase from '../../supabase-client.js';

export const useBibles = () => {
  const [bibles, setBibles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Cargar todas las biblias
  const fetchBibles = async () => {
    try {
      setLoading(true);
      setError(null);

      const { data, error } = await supabase.rpc('get_all_bibles');


      if (error) {
        console.error('❌ Error loading bibles:', error);
        setError('Error al cargar biblias');
        return;
      }

      // Mapear los datos para que coincidan con el formato esperado por los componentes
      const mappedBibles = (data || []).map(bible => {
        return {
          bible_id: bible.bible_id,
          title_bible: bible.bible_title,
          price_bible: bible.bible_price,
          price_cover: bible.bible_price_cover || 0,
          total_with_cover: bible.bible_total_with_cover || 0,
          price_tab_index: bible.bible_price_tab_index || 0,
          total_with_tab_index: bible.bible_total_with_tab_index || 0,
          total_with_both: bible.bible_total_with_both || 0,
          description_bible: bible.bible_description,
          format_bible: bible.bible_format,
          pages_bible: bible.bible_pages,
          version_bible: bible.bible_version,
          language_bible: bible.bible_language,
          available_bible: bible.bible_available,
          has_cover: bible.bible_has_cover,
          has_tab_index: bible.bible_has_tab_index,
          favorite_product: bible.bible_favorite_product,
          favorite_count_product: bible.bible_favorite_count_product,
          image_urls: bible.bible_image_urls || [],
          characters_bible: bible.bible_characters_bible || []
        };
      });


      setBibles(mappedBibles);
    } catch (err) {
      console.error('Error fetching bibles:', err);
      setError('Error al cargar biblias');
    } finally {
      setLoading(false);
    }
  };

  // Agregar nueva biblia
  const addBible = async (bibleData) => {
    try {
      const { data, error } = await supabase.rpc('create_bible', {
        p_title: bibleData.title,
        p_price: parseFloat(bibleData.price) || 0,
        p_price_cover: parseFloat(bibleData.price_cover) || 0,
        p_total_with_cover: parseFloat(bibleData.total_with_cover) || 0,
        p_price_tab_index: parseFloat(bibleData.price_tab_index) || 0,
        p_total_with_tab_index: parseFloat(bibleData.total_with_tab_index) || 0,
        p_total_with_both: parseFloat(bibleData.total_with_both) || 0,
        p_description: bibleData.description || '',
        p_format: bibleData.format || '',
        p_pages: parseInt(bibleData.pages) || 0,
        p_version: bibleData.version || '',
        p_language: bibleData.language || '',
        p_available: bibleData.available !== false,
        p_has_cover: bibleData.has_cover !== false,
        p_has_tab_index: bibleData.has_tab_index !== false,
        p_image_urls: bibleData.image_urls || null,
        p_characters_bible: bibleData.characters_bible || null
      });

      if (error) {
        console.error('Error creating bible:', error);
        throw new Error(error.message || 'Error al crear biblia');
      }

      // Recargar biblias después de crear
      await fetchBibles();
      return data;
    } catch (err) {
      console.error('Error adding bible:', err);
      throw err;
    }
  };

  // Actualizar biblia existente
  const updateBible = async (bibleId, bibleData) => {
    try {
      const { data, error } = await supabase.rpc('update_bible', {
        p_bible_id: bibleId,
        p_title: bibleData.title,
        p_price: parseFloat(bibleData.price) || 0,
        p_price_cover: parseFloat(bibleData.price_cover) || 0,
        p_total_with_cover: parseFloat(bibleData.total_with_cover) || 0,
        p_price_tab_index: parseFloat(bibleData.price_tab_index) || 0,
        p_total_with_tab_index: parseFloat(bibleData.total_with_tab_index) || 0,
        p_total_with_both: parseFloat(bibleData.total_with_both) || 0,
        p_description: bibleData.description || '',
        p_format: bibleData.format || '',
        p_pages: parseInt(bibleData.pages) || 0,
        p_version: bibleData.version || '',
        p_language: bibleData.language || '',
        p_available: bibleData.available !== false,
        p_has_cover: bibleData.has_cover !== false,
        p_has_tab_index: bibleData.has_tab_index !== false,
        p_image_urls: bibleData.image_urls || null,
        p_characters_bible: bibleData.characters_bible || null
      });

      if (error) {
        console.error('Error updating bible:', error);
        throw new Error(error.message || 'Error al actualizar biblia');
      }

      // Recargar biblias después de actualizar
      await fetchBibles();
      return data;
    } catch (err) {
      console.error('Error updating bible:', err);
      throw err;
    }
  };

  // Eliminar biblia
  const deleteBible = async (bibleId) => {
    try {
      const { data, error } = await supabase.rpc('delete_bible', {
        p_bible_id: bibleId
      });

      if (error) {
        console.error('Error deleting bible:', error);
        throw new Error(error.message || 'Error al eliminar biblia');
      }

      // Recargar biblias después de eliminar
      await fetchBibles();
      return data;
    } catch (err) {
      console.error('Error deleting bible:', err);
      throw err;
    }
  };

  // Cargar biblias al montar el componente
  useEffect(() => {
    fetchBibles();
  }, []);

  return {
    bibles,
    loading,
    error,
    fetchBibles,
    addBible,
    updateBible,
    deleteBible
  };
};

